module.exports = {"title":"Uznanie autorstwa"};